import React from 'react';
import SafeIcon from '../common/SafeIcon';

const ProductCard = ({ product }) => {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-sm overflow-hidden group hover:border-zinc-700 transition-colors flex flex-col min-w-[280px] w-full">
      <div className="relative aspect-square overflow-hidden bg-zinc-950">
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500 mix-blend-luminosity group-hover:mix-blend-normal"
        />
        <div className="absolute top-4 left-4 flex gap-1">
          <span className="bg-zinc-950/80 backdrop-blur text-xs font-bold px-2 py-1 uppercase tracking-wider border border-zinc-800">
            {product.category.replace('-', ' ')}
          </span>
        </div>
      </div>
      
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex justify-between items-start mb-2">
          <div>
            <h3 className="text-lg font-bold uppercase tracking-tight">{product.name}</h3>
            <p className="text-sm text-zinc-500">{product.tagline}</p>
          </div>
          <span className="text-lg font-bold text-red-500">${product.price}</span>
        </div>
        
        <div className="flex items-center gap-2 mb-6">
          <div className="flex text-red-500 text-sm">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} name="Star" fill="currentColor" className={i === 4 ? 'opacity-50' : ''} />
            ))}
          </div>
          <span className="text-xs text-zinc-500">({product.reviews})</span>
        </div>
        
        <button className="mt-auto w-full bg-zinc-950 hover:bg-zinc-800 border border-zinc-800 text-white py-3 rounded-sm font-bold uppercase text-sm tracking-wider transition-colors flex justify-center items-center gap-2">
          Add to Protocol
          <SafeIcon name="Plus" />
        </button>
      </div>
    </div>
  );
};

export default ProductCard;